<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 470px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <b-card-header>
            <div>
              <span style="font-size:20px; color: #fff;">ปริมาณยานพาหนะแต่ละประเภท (วัน)</span>
            </div>
            <b-dropdown
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              text="รายงาน"
              split
              variant="primary"
              right
            >
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถรายวัน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถรายเดือน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถ (PCU) รายวัน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถ (PCU) รายเดือน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถกราฟรายวัน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถกราฟรายเดือน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถกราฟ (PCU) รายวัน
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                target="_blank"
                :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
              >
                สรุปปริมาณรถกราฟ (PCU) รายเดือน
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <div>
            <app-echart-line
              :option-data="option"
              style="width: 100%; height:300px; margin-left: 20px; margin-top: 10px;"
            />
          </div>
          <div class="pie-text1 text-center">
            <div
              v-for="(data,index) in option.series"
              :key="index"
              class="d-flex justify-content-between"
            >
              <div class="series-info">
                <br>
                <feather-icon
                  icon="CircleIcon"
                  size="16"
                  class="mr-50"
                  :style="{fill: option.series[index].color, color:option.series[index].color}"
                />
                <span class="font-weight-bolder">{{ option.series[index].name }}</span>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BDropdown, BDropdownItem, BDropdownDivider, BCardHeader, BCard,
// BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartLine from './AppEchartLine.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartLine,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BCardHeader,
    BCard,
    // BCardText,
  },
  data() {
    return {
      pid: '',
      rtsp: [],
      name: [],
      option: {
        xAxisData: [],
        series: [
          {
            name: 'รถยนต์',
            type: 'line',
            data: [],
            color: '#579BFE ',
          },
          {
            name: 'รถจักรยานยนต์',
            type: 'line',
            data: [],
            color: '#DC48FF ',
          },
          {
            name: 'รถเเท็กซี่',
            type: 'line',
            data: [],
            color: '#8246FE ',
          },
          {
            name: 'รถกระบะ',
            type: 'line',
            data: [],
            color: '#FE447A ',
          },
          {
            name: 'รถบัส',
            type: 'line',
            data: [],
            color: '#4EAF51 ',
          },
          {
            name: 'รถบรรทุก',
            type: 'line',
            data: [],
            color: '#FF805D ',
          },
          {
            name: 'รถพ่วง',
            type: 'line',
            data: [],
            color: '#FDFF01',
          },
        ],
      },
    }
  },
  mounted() {
    this.graphLine()
    this.pid = this.$route.query.pid
  },
  methods: {
    graphLine() {
      axios.post('/getLineCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.option.xAxisData.push(value.Period_Name)
            this.option.series[0].data.push(value.Car_PCU)
            this.option.series[1].data.push(value.Bike_PCU)
            this.option.series[2].data.push(value.Taxi_PCU)
            this.option.series[3].data.push(value.Pickup_PCU)
            this.option.series[4].data.push(value.Bus_PCU)
            this.option.series[5].data.push(value.Truck_PCU)
            this.option.series[6].data.push(value.Trailer_PCU)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
  .pie-text1{
    width: 200px;
    position:absolute;
    margin: auto;
    left: 89%;
    right: 0;
    top: 25%;
    bottom: 0;
  }
</style>
